var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "175px",
    height: "175px",
    viewBox: "0 0 175 175",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chart/icon/area") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart/icon/area",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(3.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "analytics"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.170358,19.3817813 C115.13147,19.3817813 114.914788,106.021767 133.561173,106.021767 C126.304605,106.021767 74.03611,106.021767 66.7795425,106.021767 C85.4259275,106.022212 85.21008,19.3817813 100.170358,19.3817813 Z",
    id: "Shape",
    fill: "#B7C140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3887275,0.198753297 C48.3510925,0.198753297 48.1339925,106.023101 66.7795425,106.023101 C59.522975,106.023101 7.2565675,106.023101 0,106.023101 C18.6442975,106.022212 18.4297025,0.198753297 33.3887275,0.198753297 Z",
    id: "Shape",
    fill: "#243B81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.560755,71.4853806 C148.521867,71.4853806 148.303933,106.022212 166.950317,106.022212 C159.69375,106.022212 107.426508,106.022212 100.16994,106.022212 C118.81883,106.022212 118.600895,71.4853806 133.560755,71.4853806 Z",
    id: "Shape",
    fill: "#F5A623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.224553,84.6408925 C123.462683,96.9311384 127.522035,106.021767 133.562008,106.021767 C129.933098,106.021767 115.052145,106.021767 100.171193,106.021767 C110.987783,106.022212 115.457955,94.4015914 120.224553,84.6408925 Z",
    id: "Shape",
    fill: "#C1AB40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7795425,40.7888898 C81.7419075,40.7888898 81.5248075,106.023101 100.170358,106.023101 C92.912955,106.023101 40.645295,106.023101 33.3887275,106.023101 C52.0351125,106.022212 51.81843,40.7888898 66.7795425,40.7888898 Z",
    id: "Shape",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.400000, 72.031396)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4644227,0 C21.9665408,18.9613493 26.327275,34.2371452 33.4,34.2371452 C29.7700918,34.2371452 14.8862987,34.2371452 0,34.2371452 C9.61349371,34.2371452 14.2139388,16.8524507 18.4644227,0 Z",
    fill: "#6377B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0664033,2.6678295 C53.1268724,18.4445035 57.7352522,33.7925069 66.8,33.7925069 C51.9157893,33.7925069 37.0286554,33.7925069 33.4,33.7925069 C40.9730276,33.7929498 45.436495,19.5662213 49.0664033,2.6678295 Z",
    fill: "#ACB16D"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea);
export default __webpack_public_path__ + "static/media/area.e0ab7b782bcaebd2668d1911a51e62c2.svg";
export { ForwardRef as ReactComponent };